import { ref, onMounted } from 'vue'

import type { CarouselApi } from '@toni/brand-ui'

let isFirstSliderInitialized = false

export function useImageSliderNavigation (maxImages: number) {
  const currentIndex = ref(0)
  const initialIndex = ref<number | null>(null)
  const lastIndex = ref<number | null>(null)
  const hasUserInteracted = ref(false)
  const isFirstSlider = ref(false)

  function updateUrlWithoutPush (index: number) {
    const url = new URL(window.location.href)
    url.hash = `image=${index}`
    history.replaceState(null, '', url.toString())
  }

  // Initialize from URL hash on mount
  onMounted(() => {
    if (!isFirstSliderInitialized) {
      isFirstSlider.value = true
      isFirstSliderInitialized = true
    }

    if (!isFirstSlider.value) return

    const hash = window.location.hash
    const match = hash.match(/#image=(\d+)/)
    if (match) {
      // Convert from 1-indexed to 0-indexed
      const index = parseInt(match[1]) - 1
      // If index is out of bounds, default to first slide
      if (index >= maxImages || index < 0) {
        currentIndex.value = 0
        initialIndex.value = 0
      } else {
        currentIndex.value = index
        initialIndex.value = index
        lastIndex.value = index
        hasUserInteracted.value = true // Consider URL navigation as user interaction
      }
    }
  })

  // Update URL hash when slide changes
  const onSlideChange = (api: CarouselApi) => {
    // Handle initial scroll if needed
    if (initialIndex.value !== null) {
      api.scrollTo(initialIndex.value)
      initialIndex.value = null
      return
    }

    const index = api.selectedScrollSnap()

    // Only update if the index has actually changed
    if (lastIndex.value !== index) {
      currentIndex.value = index
      lastIndex.value = index

      // Only update URL if user has interacted with the carousel
      if (hasUserInteracted.value && isFirstSlider.value) {
        updateUrlWithoutPush(index + 1)
      }
      hasUserInteracted.value = true
    }
  }

  return {
    currentIndex,
    onSlideChange
  }
}
